export type Scope = BaseScopes | string;

export enum BaseScopes {
    ADMIN = "admin",
    MAINTAIN = "user:maintain",
    ANNOUNCE = "user:announce",
    USER = "user"
}

export enum GroupScopes {
    MANAGER = "manager",
    MEMBER = "member",
    VIEWER = "viewer"
}